import { NotificationsContextProvider } from "@shared/contexts/NotificationsContext";
import { UserContextProvider } from "@shared/contexts/UserContext";
import { ReactNode } from "react";
import { ChainlitProvider } from "./ChainlitProvider";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AdaptivityContextProvider } from "@/shared/contexts/adaptivityContext";
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
// import { BackendFactory } from 'dnd-core';

interface IProps {
  children: ReactNode
}

// раскомментировать когда понадобится перетаскивание файлов в файловом браузере
// const DndProviderTyped = DndProvider as React.ComponentType<{
//   backend: BackendFactory;
//   children: ReactNode;
// }>;

const queryClient = new QueryClient();

export const AppProviders = ({ children }: IProps) => {
  return (
    // <DndProviderTyped backend={HTML5Backend}>
    <ChainlitProvider>
      <QueryClientProvider client={queryClient}>
        <AdaptivityContextProvider>
          <NotificationsContextProvider>
            <UserContextProvider>
              {children}
            </UserContextProvider>
          </NotificationsContextProvider>
        </AdaptivityContextProvider>
      </QueryClientProvider>
    </ChainlitProvider>
    // </DndProviderTyped>
  );
};